import { Component, inject, input, output } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { AdaaHelper } from "../../../../core/utils";
import { Constants } from "../../../constants/constants";
import { PageMode } from "../../../constants/enums";
import { IntpCountrySectorModel, TableActionEvent } from "../../../models";
import { LanguageService } from "../../../services";
import { ConfirmationModalComponent } from "../../general";
import { DataTableComponent } from "../../table/data-table/data-table";
import { IntpCountrySectorModalComponent } from "../intp-country-sector-modal/intp-country-sector-modal";

@Component({
  selector: "adaa-intp-country-sectors-table",
  imports: [DataTableComponent],
  templateUrl: "./intp-country-sectors-table.html",
  styleUrl: "./intp-country-sectors-table.scss",
})
export class IntpCountrySectorsTableComponent {
  private readonly _modalService = inject(NgbModal);
  private readonly _languageService = inject(LanguageService);

  sectors = input.required<IntpCountrySectorModel[]>();
  isDisabled = input<boolean>(false);
  invalid = input<boolean>(false);
  valueChanged = output<IntpCountrySectorModel[]>();

  public get tableData() {
    return AdaaHelper.clone(this.sectors());
  }

  Constants = Constants;

  public addNewClicked() {
    const sector: IntpCountrySectorModel = {
      nameAE: "",
      nameEN: "",
      status: Constants.OBJECT_STATUS.ACTIVE,
      fakeId: Math.floor(Math.random() * 217 * 1000),
    };

    this._openEditorModal(sector, PageMode.create);
  }

  public actionClicked(event: TableActionEvent) {
    if (event.event === "view") this._openEditorModal(event.data, PageMode.view);
    else if (event.event === "edit") this._openEditorModal(event.data, PageMode.edit);
    else this._openDeleteModal(event.data);
  }

  private _openEditorModal(sector: IntpCountrySectorModel, pageMode: PageMode) {
    const modal = this._modalService.open(IntpCountrySectorModalComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      modalDialogClass: this._languageService.modalDirection(),
    });

    modal.componentInstance.pageMode.set(pageMode);
    modal.componentInstance.sector.set(sector);

    modal.result.then((e) => {
      if (!e) return;
      if (pageMode === PageMode.create) {
        this.sectors().push(e);
      } else {
        const index = this.sectors().findIndex((sector) =>
          e.fakeId ? e.fakeId === sector.fakeId : e.id === sector.id
        );
        if (index > -1) this.sectors().splice(index, 1, e);
      }

      this.valueChanged.emit(this.sectors());
    });
  }

  private _openDeleteModal(sector: IntpCountrySectorModel) {
    const modal = this._modalService.open(ConfirmationModalComponent, {
      centered: true,
      size: "md",
      modalDialogClass: this._languageService.modalDirection(),
    });

    modal.componentInstance.header = "international_projects.countries.delete_sector_title";
    modal.componentInstance.title = "international_projects.countries.delete_sector_msg";

    modal.result.then((e) => {
      if (e) this._deleteConfirmed(sector);
    });
  }

  private _deleteConfirmed(sector: IntpCountrySectorModel) {
    const index = this.sectors().findIndex((e) => (sector.fakeId ? e.fakeId === sector.fakeId : e.id === sector.id));
    if (index > -1) this.sectors().splice(index, 1);

    this.valueChanged.emit(this.sectors());
  }
}
